import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import dynamic from 'next/dynamic';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import Link from '@nubank/nuds-web/components/Link/Link';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

function SectionBusiness({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  const intl = useIntl();

  return (
    <Box
      paddingHorizontal={{ md: '8x', lg: '12x' }}
      paddingVertical={{ md: '20x' }}
      display="grid"
      tag="section"
      width="100%"
      gridTemplateRows="auto"
      gridColumnGap={{
        xs: '4x',
      }}
      gridTemplateColumns={{
        md: '30% auto',
        lg: 'repeat(12,1fr)',
      }}
      gridTemplateAreas={{
        xs: `
          "image"
          "title"
          "description"
        `,
        md: `
          "title title"
          "image image"
          ". description"
        `,
        lg: `
          ". title title title title title . image image image image ."
          ". description description description description description. image image image image ."
        `,
      }}
    >
      <Box
        paddingBottom={{ md: '12x', lg: '0x' }}
        gridArea="image"
        paddingLeft={{ lg: '36x' }}
        maxWidth={{ lg: '36rem' }}
        justifySelf={{ lg: 'end' }}
        paddingHorizontal={{ md: '4x' }}
      >
        <ResponsiveImages
          loading="lazy"
          position="flex-end"
          fileName="2-women-working-landscape/2-women-working-landscape.jpg"
          alt={intl.formatMessage({ id: 'PIX.BUSINESS.IMAGE_ALT' })}
        />
      </Box>

      <Box
        paddingTop={{ xs: '8x', md: 0 }}
        paddingHorizontal={{ xs: '6x', md: '4x' }}
        gridArea="title"
      >
        <Typography
          variant="title"
          intlKey={`cms.pixPage.pixCardsArea[${index}].title`}
          gutterBottom={1.5}
        />
      </Box>

      <Box
        paddingHorizontal={{ xs: '6x', md: '4x' }}
        gridArea="description"
      >
        <Typography
          variant="subtitle"
          intlKey={`cms.pixPage.pixCardsArea[${index}].description`}
          gutterBottom={1.5}
        />
        <Link
          variant="action"
          color="primary"
          intlKey={`cms.pixPage.pixCardsArea[${index}].ctaText`}
          href={formatMessage({ id: `cms.pixPage.pixCardsArea[${index}].ctaLink` })}
        />
      </Box>
    </Box>
  );
}

SectionBusiness.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionBusiness);
